import { MouseEvent, forwardRef } from 'react';
import { IconButton, Select as MuiSelect, SelectProps as MuiSelectProps } from '@mui/material';
import { CloseIcon } from '~/icons';

export interface ClearableSelectProps extends Omit<MuiSelectProps, 'startAdornment'> {
  onClear: () => void;
  showClearButton?: boolean;
}

const ClearableSelect = forwardRef<HTMLDivElement, ClearableSelectProps>(
  ({ onClear, children, showClearButton = true, ...rest }, ref) => {
    const handleClear = (event: MouseEvent) => {
      event.stopPropagation();
      onClear();
    };

    const shouldShowClearButton =
      showClearButton && rest.value !== '' && rest.value !== null && rest.value !== undefined;

    return (
      <MuiSelect
        value={rest.value}
        {...rest}
        ref={ref}
        endAdornment={
          shouldShowClearButton ? (
            <IconButton
              sx={{
                position: 'absolute',
                right: 32,
              }}
              size="small"
              onClick={handleClear}
            >
              <CloseIcon />
            </IconButton>
          ) : (
            rest.endAdornment
          )
        }
      >
        {children}
      </MuiSelect>
    );
  },
);

export default ClearableSelect;
